import { atom, selectorFamily } from 'recoil'

import { messageDetailsState } from 'Hooks/useMessageDetails'
import { errorState } from 'Recoil/state/errorState'

export const pageState = atom({
  key: 'messageCheckupSpamCheckPageState',
  default: {
    error: false
  }
})

export const spamAssassinState = atom({
  key: 'messageCheckupSpamCheckSpamAssassinState',
  default: {
    loading: true,
    spamCheck: {}
  }
})

export const deliverabilityState = atom({
  key: 'messageCheckupSpamCheckDeliverabilityState',
  default: {
    loading: false,

    firstCheck: true,
    results: []
  }
})

export const pageLoadingState = selectorFamily({
  key: 'messageCheckupSpamCheckLoadingState',
  get: idMessage => ({ get }) => {
    const { loading } = get(messageDetailsState(idMessage))
    return loading
  }
})

export const pageErrorState = selectorFamily({
  key: 'messageCheckupSpamCheckErrorgState',
  get: idMessage => ({ get }) => {
    const { error: messageError } = get(messageDetailsState(idMessage))
    const { error: pageError } = get(pageState)
    const { error: globalError } = get(errorState)
    return messageError || pageError || globalError
  }
})
